var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.validOffer
    ? _c("div", { staticClass: "offer-summary-item" }, [
        _c("div", { staticClass: "offer-info" }, [
          _c("div", { staticClass: "offer-name" }, [
            _vm._v("\n\t\t\t" + _vm._s(_vm.offer.name) + "\n\t\t")
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "offer-description" }, [
            _vm._v("\n\t\t\t" + _vm._s(_vm.offer.description) + "\n\t\t")
          ])
        ]),
        _vm._v(" "),
        _c(
          "a",
          { staticClass: "remove-offer", on: { click: _vm.removeOffer } },
          [_vm._v("Remove")]
        ),
        _vm._v(" "),
        _c("small", [_vm._v("(apply offer later)")])
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-10b6b2c6", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-10b6b2c6","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/checkout/OfferSummaryItem.vue
// module id = null
// module chunks = 